import { Account, CashDrawerOperation as CashDrawerOperationType, VenueShiftsQuery } from '../../../generated/graphql';
import { MakeRequired } from '../../../types';

export type VenueShifts = VenueShiftsQuery['venueShifts'];
export type VenueShift = VenueShifts[0];

export type ClosedVenueShift = MakeRequired<VenueShift>;

const isNotNull = (val: unknown) => val !== null;

export const closedShiftGuard = (venueShift: ClosedVenueShift | VenueShift): venueShift is ClosedVenueShift => {
    const allDefined = isNotNull(venueShift.finishedBy) &&
    isNotNull(venueShift.finishedUtc) &&
    isNotNull(venueShift.expectedCashAmount) &&
    isNotNull(venueShift.finalCashAmount) &&
    isNotNull(venueShift.expectedCreditCardAmount) &&
    isNotNull(venueShift.finalCreditCardAmount) &&
    isNotNull(venueShift.cashIncome);
    return allDefined;
};

export interface Employee {
    account: Pick<Account, 'firstName' | 'lastName' | 'imageUrl'>;
}

export interface CashDrawerOperation extends Pick<CashDrawerOperationType, 'id' | 'amount' | 'createdUtc' | 'note'> {
    createdBy: Employee;
}